export const RESTAURENT_ADMIN = null;
//export const SUPER_ADMIN_ID = "67221cf92c638d3801986d91";
export const SUPER_ADMIN_ID = "5efd82a774f06456cc896ebf";
export const RESTAURANT_ID_KEY = "rId";
